import React from 'react';
import authManager from '../lib/authManager';

export const CurrentUserName = () => <span>{authManager.userName || '...'}</span>;
